








import { defineComponent } from "@vue/composition-api";
import useDarkModeController from "@/hooks/useDarkModeController";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "DarkModeSwitch",
  components: { BaseIconButton },
  setup() {
    const { toggleDarkMode, isDarkMode } = useDarkModeController();

    return { toggleDarkMode, isDarkMode };
  },
});
